export default "__VITE_ASSET__DBBqWszt__"